module.exports = __webpack_public_path__ + "fonts/fontello.d7a68c14.woff2";